<template>
    <v-card flat class="score-trans ma-1" :height="getChartHeight()">
        <v-container fluid>
            <v-row dense>
                <v-col cols="12">
                    <v-card flat class="score-trans mt-2">
                        <h3>Upcoming arrivals</h3>
                        <h5>{{ this.title }}</h5>
                    </v-card>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">                    
                    <v-card flat fluid :height="getChartHeight() - chart_correction" class="score-trans">
                        <canvas id="arrivalsv1-chart1" height="300" style="width:100%;"></canvas>
                    </v-card>    
                </v-col>
            </v-row>
            <div id="drilldown" :class="{'drill-hide': !open, 'drill-show': open}" class="drill-down">
                <div class="drill-header">
                    <div>Week {{this.week}}</div>
                    <div>
                        <v-icon size="20" @click.stop="test()">mdi-close</v-icon>
                    </div>
                </div>
                <div class="drill-grid" v-for="(day, i) in weekdata[this.week]" :key="i">                    
                    <div>{{ day.day }}</div>
                    <div>{{ day.date }}</div>
                    <div class="push-right">{{ day.arrivals }}</div>
                </div>
            </div>
        </v-container>
    </v-card>
</template>

<script>

    import mxchart from '@/components/js/charts/arrivals_chart_V1';
    import mxscreensize from '@/components/js/screensize';

    import { Chart, registerables } from 'chart.js'
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    Chart.register(...registerables, ChartDataLabels); // registered globally

    export default {
        props: {
            height_correction: Number,
            chart_correction: Number,
        },           
        data() {
            return {
                arrivals: [],
                chart: null,
                week: 0,
                open: false,
                weekdays: [],
                weekdata: {},
            }
        },
        created(){ // set up event bus listener here on created event
            this.getData('load');
        },                  
        mixins:[mxchart, mxscreensize],
        methods:{
            getChartHeight(){
                if((((this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2) < 200){
                   return (((this.wInnerWidth - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2);
                }
                return (((this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2);
            },
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },
            getData(param){         
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getArrivalsv3.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getArrivals"
                    },
                    })
                    .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.weekdata = res.data.getWeekDetails
                        this.arrivals = res.data.getArrivals;    
                        //console.log(JSON.stringify(this.arrivals));

                        if(param ==='load'){
                            const ctx = document.getElementById('arrivalsv1-chart1').getContext('2d');
                            this.chart = new Chart(ctx, this.createBarData(this.arrivals)); // horizontalBar, bar                                
                        } else {
                            this.refreshChart(this.createBarData(this.arrivals));
                        }
                    }
                    })
                    .finally(() => {
                });
            },
            showDrillDown(x, y){
                console.log(x, y)
                let drilldown = document.getElementById('drilldown');
                drilldown.style.position = "absolute"
                drilldown.style.left = (x-50) +'px'
                drilldown.style.top = (y-30)+'px'
                this.weekdays = this.weekdata[this.week]
            },    
            test(){
                console.log('click');
                this.open=false
                console.log(this.open)
            }               
        }
    }
</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
    .drill-down{
        padding: 4px;
        border: 1px solid;
        border-radius: 5px;
        font-size: 8pt;
        background: #ffff;
        width: fit-content;
    }
    .drill-header{
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 600;
        font-size: 10pt;
        justify-content: space-between;
        margin-top: 1px;
        margin-bottom: 5px;
    }
    .drill-grid{
        display: grid;
        grid-template-columns: 40px 35px 30px;
        gap: 5px;
    }
    .push-right{
        text-align: right;
    }
    .drill-hide{
        opacity: 0;
        transition: opacity 1s;
    }
    .drill-show{
        opacity: 1;
        transition: opacity 1s;
    }
</style>